import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Slide, { SlideProps } from '@mui/material/Slide';
import MuiAlert, { AlertProps, AlertColor } from '@mui/material/Alert';

interface Props {
  className?: string
  alertClassName?: string
  message: string | React.ReactNode
  open: boolean
  handleClose?: () => null
  position?: { vertical: 'top' | 'bottom', horizontal: 'center' | 'left' | 'right' }
  alertSeverity?: AlertColor
  autoHideDuration?: number
  containerStyles?: object
}

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="down" />;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>((
  props,
  ref,
) => <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />);

const Toast = (props: Props) => {
  const {
    message, open,
    className = undefined,
    alertClassName = undefined,
    handleClose = () => null,
    position = { vertical: 'bottom', horizontal: 'center' },
    alertSeverity = 'info',
    autoHideDuration = 2000,
    containerStyles = {},
  } = props;

  return (
    <Snackbar
      anchorOrigin={position}
      className={className ?? ''}
      open={open}
      onClose={handleClose}
      TransitionComponent={SlideTransition}
      message={message}
      key={SlideTransition.name}
      autoHideDuration={autoHideDuration}
      style={{ ...containerStyles }}
    >
      <Alert className={`toast_msg ${alertClassName} ${alertSeverity}`} severity={alertSeverity} icon={false}>{message}</Alert>
    </Snackbar >
  );
};

export default Toast;
